import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";
import { addisLoading, addservices } from "../../utils/redux/mainSlice";
import { getServices } from "../../utils/apis/func";

const EditPromoCode = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchServices = async () => {
      dispatch(addisLoading(true));
      const res: any = await getServices("");
      console.log(res);
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addservices(res?.data?.services));
      }
      dispatch(addisLoading(false));
    };
    fetchServices();
  }, [dispatch]);

  const { id } = useParams();
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState({
    code: "",
    services: [] as string[],
    percentageDiscount: 0,
    applyToAllServices: false,
    active: true,
  });

  const [services, setServices] = useState<Record<string, string>>({});
  const [availableServices, setAvailableServices] = useState<string[]>([]);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [promoCode, setPromoCode] = useState<string>("");
  const [selectedAllServices, setSelectedAllServices] = useState<string[]>([]);
  const [percentageDiscount, setPercentageDiscount] = useState<string>("");
  const [promoStatus, setPromoStatus] = useState<boolean | string>();

  const fetchPromoCode = async () => {
    try {
      const AuthToken = await localStorage.getItem("AuthToken");
      const response = await axios.get(
        `https://api.pureworker.com/api/admin/promos?_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === "success") {
        const promo = response.data.data[0];
        setPromoStatus(promo.active);
        setPromoCode(promo.code);
        setPercentageDiscount(String(promo.percentageDiscount));

        if (promo.applyToAllServices) {
          setSelectedAllServices(allServicesFiltered);
        } else if (promo.services && !promo.applyToAllServices) {
          setSelectedAllServices(promo.services ?? []);
        }
      }
    } catch (error) {
      console.error("Error fetching promo code:", error);
    }
  };

  const fetchServices = async () => {
    try {
      const AuthToken = await localStorage.getItem("AuthToken");
      const response = await axios.get(
        "https://api.pureworker.com/api/admin/services",
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === "success") {
        const servicesData = response.data.data || [];
        const servicesMap: Record<string, string> = {};
        servicesData.forEach((service: any) => {
          servicesMap[service._id] = service.name;
        });

        setServices(servicesMap);
        setAvailableServices(Object.keys(servicesMap));
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  useEffect(() => {
    fetchPromoCode();
    fetchServices();
  }, [id]);

  const allServices = useAppSelector((store: RootState) => store.user.services);

  const allServicesFiltered = searchQuery.trim()
    ? allServices.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
      )
    : allServices;

  const handleCheck = (service: any) => {
    setSelectedAllServices((prevSelected) => {
      const isSelected = prevSelected.includes(service._id);
      if (isSelected) {
        return prevSelected.filter((id) => id !== service._id);
      } else {
        return [...prevSelected, service._id];
      }
    });
  };

  const handlePromoStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPromoStatus(e.target.value === "true");
  };

  const handleSelectAllService = () => {
    if (selectedAllServices.length === allServicesFiltered.length) {
      setSelectedAllServices([]);
    } else {
      const allServiceIds = allServicesFiltered.map((service) => service._id);
      setSelectedAllServices(allServiceIds);
    }
  };

  const handleCancel = () => {
    setSearchQuery("");
    setSelectedAllServices(initialValue.services);
    setIsFocused(false);
  };

  const handleCreatePromoCode = async () => {
    dispatch(addisLoading(true));
    const AuthToken = await localStorage.getItem("AuthToken");
    const promoPayload = {
      code: promoCode,
      applyToAllServices:
        selectedAllServices.length === allServicesFiltered.length
          ? true
          : false,
      percentageDiscount: parseFloat(percentageDiscount),
      services: selectedAllServices,
      active: promoStatus,
    };

    console.log(promoPayload);

    try {
      const response = await axios.patch(
        `https://api.pureworker.com/api/admin/promo/${id}`,
        promoPayload,
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Promo code saved successfully!");
        // setPromoCode("");
        // setSelectedAllServices([]);
        // setPercentageDiscount("");
        // handleCancel();
        navigate(-1);
      } else {
        toast.error("Failed to save promo code. Please try again.");
      }
    } catch (error) {
      console.error("Error saving promo code:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      dispatch(addisLoading(false));
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-8">
      <div className="flex justify-between items-center mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-purple-600 hover:underline"
        >
          Back
        </button>
        <h2 className="text-2xl font-semibold">Edit Promo Code</h2>
      </div>
      <div className="mb-4">
        <label htmlFor="code" className="block font-medium mb-1">
          Code
        </label>
        <input
          type="text"
          id="code"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          placeholder="Enter promo code"
          className="w-full border border-gray-300 rounded p-2"
        />
      </div>

      <div className="mb-4">
        <label htmlFor="services" className="block font-medium mb-1">
          Services
        </label>
        <div className="border border-gray-300 rounded p-2">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onFocus={() => setIsFocused(true)}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border-b mb-2"
          />
          {isFocused && (
            <>
              <div className="overflow-y-auto max-h-64">
                {allServicesFiltered?.map((service) => (
                  <div key={service._id} className="flex items-center p-2">
                    <input
                      type="checkbox"
                      className="mr-2"
                      checked={selectedAllServices.includes(service._id)}
                      onChange={() => handleCheck(service)}
                    />
                    <label>{service.name}</label>
                  </div>
                ))}
              </div>
              <div className="flex justify-between mt-4">
                <button
                  onClick={handleSelectAllService}
                  className="text-purple-600 hover:underline"
                >
                  {selectedAllServices.length === allServicesFiltered.length
                    ? "Unselect All"
                    : "Select All"}
                </button>
                <button
                  onClick={handleCancel}
                  className="text-white bg-[#88087B] py-2 px-4 rounded"
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="mb-6">
        <label htmlFor="discount" className="block font-medium mb-1">
          Discount (%)
        </label>
        <input
          type="text"
          id="discount"
          value={percentageDiscount}
          onChange={(e) => setPercentageDiscount(e.target.value)}
          placeholder="Enter discount percentage"
          className="w-full border border-gray-300 rounded p-2"
        />
      </div>
      <div className="mb-6">
        <label htmlFor="promoStatus" className="block font-medium mb-1">
          Promo Status
        </label>
        <select
          className="block font-medium mb-1"
          id="promoStatus"
          name="promoStatus"
          value={promoStatus ? "true" : "false"}
          onChange={handlePromoStatusChange}
        >
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
      </div>
      <button
        className="w-full bg-[#88087B] text-white py-2 rounded"
        onClick={handleCreatePromoCode}
      >
        Save
      </button>
    </div>
  );
};

export default EditPromoCode;
